import { render, staticRenderFns } from "./UITabBarTab.vue?vue&type=template&id=300ead58&scoped=true&"
import script from "./UITabBarTab.vue?vue&type=script&lang=js&"
export * from "./UITabBarTab.vue?vue&type=script&lang=js&"
import style0 from "./UITabBarTab.vue?vue&type=style&index=0&id=300ead58&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "300ead58",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('300ead58')) {
      api.createRecord('300ead58', component.options)
    } else {
      api.reload('300ead58', component.options)
    }
    module.hot.accept("./UITabBarTab.vue?vue&type=template&id=300ead58&scoped=true&", function () {
      api.rerender('300ead58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/UITabBarTab.vue"
export default component.exports